import { DotLoading, InfiniteScroll } from 'antd-mobile'
import { useTranslation } from "react-i18next";

const InfiniteScrollContent = ({ hasMore }: { hasMore?: boolean }) => {
    const { t } = useTranslation();

    return (
        <>
            {hasMore ? (
                <>
                    <span>Loading</span>
                    <DotLoading />
                </>
            ) : process.env.REACT_APP_IDN_ENV === 'hw' ? null : (
                <span>--- {t('common.no-more')} ---</span>
            )}
        </>
    )
}

const InfiniteScrollTem = ({ loadMore, hasMore }) => {
    return (
        <InfiniteScroll loadMore={loadMore} hasMore={hasMore}>
            <InfiniteScrollContent hasMore={hasMore} />
        </InfiniteScroll>
    )
}

export default InfiniteScrollTem;